import styled from 'styled-components'
import moment from 'moment'
import { FaSmile } from 'react-icons/fa'

import { P } from '../../../../style/Typography.style'

const JobComment = ({ name, comment, createdAt }) => {
  return (
    <StyledJobComment>
      <FaSmile className="avatar" />

      <div className="comment__details">
        <P size="1rem" weight="500" margin="0">
          {name || 'Anonymous'}
        </P>
        <P
          dangerouslySetInnerHTML={{
            __html: comment,
          }}
          margin="0.25rem 0"
        ></P>
        <span className="created__at">{`Created: ${moment(createdAt).format(
          'MMM Do YYYY [at] h:mm:ss a'
        )}`}</span>
      </div>
    </StyledJobComment>
  )
}

const StyledJobComment = styled.div`
  display: flex;
  align-items: center;

  .avatar {
    color: rgb(255, 123, 155);
    font-size: 36px;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    margin-right: 1rem;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .comment__details {
    display: flex;
    flex-direction: column;
    gap: 0;

    .created__at {
      font-size: 0.75rem;
      color: #adb5bd;
    }
  }
`

export default JobComment
